import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { get, del } from 'aws-amplify/api';
import LoadingSpinner from '../components/LoadingSpinner';
import '../styles/management.css';

function InvitationDetailScreen() {
  const { invitationId } = useParams();
  const navigate = useNavigate();
  const [invitation, setInvitation] = useState(null);
  const [guestResponses, setGuestResponses] = useState({});
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInvitation();
  }, [invitationId]);

  const fetchInvitation = async () => {
    try {
      const restOperation = get({
        apiName: 'events',
        path: `/invitations/${invitationId}`
      });
      const response = await restOperation.response;
      const { body } = response;
      const data = await body.json();
      setInvitation(data);
      setGuestResponses(data.responses || {});
      setLoading(false);
    } catch (err) {
      console.error('Error fetching invitation:', err);
      setError('Failed to load invitation details');
      setLoading(false);
    }
  };

  const handleEdit = () => {
    navigate(`/invitations/${invitationId}/edit`);
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this invitation?')) {
      try {
        await del('api', `/invitations/${invitationId}`);
        navigate(`/invitations/${invitation.eventId}`);
      } catch (err) {
        console.error('Error deleting invitation:', err);
        setError('Failed to delete invitation');
      }
    }
  };

  if (loading) return <LoadingSpinner message="Loading invitation details..." />;
  if (error) return <div className="error-message">{error}</div>;
  if (!invitation) return <div className="warning-message">Invitation not found</div>;

  return (
    <div className="invitation-detail">
      <h2>Invitation Details</h2>
      <div className="action-buttons">
        <button className="button button--primary" onClick={handleEdit}>Edit</button>
        <button className="button button--danger" onClick={handleDelete}>Delete</button>
      </div>
      <div className="detail-section">
        <p><strong>Event:</strong> {invitation.eventName}</p>
        <p><strong>Guest:</strong> {invitation.guestName}</p>
        <p><strong>Sent Date:</strong> {new Date(invitation.sentDate).toLocaleDateString()}</p>
        {invitation.guests && invitation.guests.map(guest => (
          <div key={guest.id} className="guest-response">
            <h3>{guest.name}</h3>
            <p><strong>Status:</strong> {guestResponses[guest.id]?.status || 'No response'}</p>
            {guestResponses[guest.id]?.responseDate && (
              <p><strong>Response Date:</strong> {new Date(guestResponses[guest.id].responseDate).toLocaleDateString()}</p>
            )}
            {guestResponses[guest.id]?.dietaryRestrictions && (
              <p><strong>Dietary Restrictions:</strong> {guestResponses[guest.id].dietaryRestrictions}</p>
            )}
            {guestResponses[guest.id]?.notes && (
              <p><strong>Notes:</strong> {guestResponses[guest.id].notes}</p>
            )}
          </div>
        ))}
      </div>
      <div className="detail-section">
        <p><strong>Email:</strong> {invitation.email}</p>
        {invitation.phone && (
          <React.Fragment>
            <p><strong>Phone:</strong> {invitation.phone}</p>
          </React.Fragment>
        )}
        {invitation.notes && (
          <React.Fragment>
            <p><strong>Notes:</strong> {invitation.notes}</p>
          </React.Fragment>
        )}
        {invitation.numberOfGuests && (
          <React.Fragment>
            <p><strong>Number of Guests:</strong> {invitation.numberOfGuests}</p>
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

export default InvitationDetailScreen;